// extracted by mini-css-extract-plugin
export default {"root":"ProfileView_root__YQ9EX","wrapper":"ProfileView_wrapper__l9mHr"};